var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "roomCallVideo",
      staticClass:
        "grm-video-layer one-fourth column flex justify-center items-center",
      class: [
        { isActiveDrag: _vm.isActiveDrag },
        { "no-user": !_vm.roomUser },
        _vm.videoSize,
        { participant: !_vm.hasEmceeRole() },
      ],
      style: _vm.grmVideoLayerStyle(_vm.videoRect),
      attrs: {
        "data-grm-comp": "RoomCallVideo.mixing",
        "data-user-id": _vm.videoRect.userId,
        "data-channel-idx": _vm.videoRect.idx,
        "data-video-only": this.videoOnly,
        "data-network-status": _vm.networkStatus,
        draggable: _vm.draggable,
      },
      on: {
        touchstart: _vm.onTouchStart,
        dragstart: _vm.onDragStart,
        dragenter: [
          _vm.onDragEnter,
          function ($event) {
            $event.preventDefault()
          },
        ],
        dragleave: [
          _vm.onDragLeave,
          function ($event) {
            $event.preventDefault()
          },
        ],
        drop: [
          _vm.onDrop,
          function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        ],
        dragover: function ($event) {
          $event.preventDefault()
        },
        mouseover: _vm.onMouseover,
        mouseleave: _vm.onMouseleave,
        dblclick: function ($event) {
          if (!$event.shiftKey) return null
          $event.preventDefault()
          return _vm.addByPassSingleVideo(_vm.videoRect.userId)
        },
      },
    },
    [
      _c(
        "div",
        { ref: "roomVideoWrapper", staticClass: "relative w-full h-full" },
        [
          _vm.showDelBtn
            ? _c("img", {
                staticClass: "video-del",
                attrs: {
                  src: require("@/assets/roomType/lms/img/video-del.svg"),
                },
                on: { click: _vm.delVideo },
              })
            : _vm._e(),
          _vm.myPreviewStreams.main
            ? _c("RoomVideo", {
                ref: "myVideo",
                style: _vm.roomVideoStyle,
                attrs: {
                  "data-video-type": "myvideo",
                  muted: true,
                  videoOnly: _vm.videoOnly,
                },
                on: {
                  pause: function ($event) {
                    _vm.loadMyPreviewStream = true
                  },
                  resize: _vm.onRoomVideoResize,
                },
              })
            : _vm._e(),
          _c(
            "GrmDraggableResizable",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.roomInfoSetting.useScreenMerger &&
                    _vm.isScreenShare &&
                    !_vm.videoOnly &&
                    _vm.myPreviewStreams.pip,
                  expression:
                    "roomInfoSetting.useScreenMerger && isScreenShare && !videoOnly && myPreviewStreams.pip",
                },
              ],
              attrs: {
                parent: true,
                w: _vm.screenSharePip.width,
                h: _vm.screenSharePip.height,
                x: _vm.screenSharePip.x,
                y: _vm.screenSharePip.y,
                "lock-aspect-ratio": _vm.screenSharePip.lockAspectRatio,
                onResize: _vm.onResize,
                onDrag: _vm.onDrag,
              },
            },
            [
              _c("RoomVideo", {
                ref: "localVideo",
                staticClass: "grm-video",
                style: _vm.roomVideoStyle,
                attrs: { muted: true, videoOnly: _vm.videoOnly },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.isScreenShare && !_vm.contentArea
        ? _c(
            "div",
            {
              staticClass: "v-bg",
              class: {
                "no-cam":
                  !!_vm.roomUser &&
                  (_vm.roomUser.roomUserRole?.camera == false ||
                    _vm.roomUser.cameraStatus != "on"),
                "no-user": !_vm.roomUser,
              },
            },
            [
              !_vm.roomUser
                ? _c("img", {
                    staticClass: "pointer-events-none",
                    style:
                      _vm.ux.useNoneVideoImageFull && _vm.ux.noneVideoImagePath
                        ? {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }
                        : {
                            height: "40%",
                          },
                    attrs: {
                      src:
                        _vm.ux.noneVideoImagePath ||
                        require("@/assets/roomType/lms/img/v-img/user1.svg"),
                    },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.roomUser
        ? [
            _c("div", {
              staticClass: "v-peakmeter",
              class: { active: _vm.roomUser.isSpeaking && !_vm.isScreenShare },
            }),
            !_vm.videoRect.screenshare
              ? _c("div", { staticClass: "v-dim" })
              : _vm._e(),
            _vm.roomGroupGroupName
              ? _c(
                  "div",
                  {
                    staticClass: "v-group",
                    style: {
                      backgroundColor: _vm.groupColor[_vm.roomGroup.groupOrder],
                    },
                  },
                  [
                    _c("div", { staticClass: "v-group-name" }, [
                      _vm._v(" " + _vm._s(_vm.roomGroupGroupName) + " "),
                    ]),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "v-name-area" }, [
              _c(
                "div",
                {
                  staticClass: "v-name ep flex items-center",
                  class: { isMe: _vm.isMe },
                },
                [
                  _vm.isOpener(_vm.roomUser.userId)
                    ? _c("GrmIcon", {
                        staticClass: "mr-1",
                        attrs: { icon: "opener" },
                      })
                    : _vm._e(),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.roomUser.nickname,
                          expression: "roomUser.nickname",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass:
                        "room-user-nickname min-w-0 max-w-max flex-1 truncate",
                    },
                    [_vm._v(_vm._s(_vm.roomUser.nickname))]
                  ),
                ],
                1
              ),
              (_vm.roomUser.micStatus === "off" ||
                _vm.roomUser.micStatus === "none" ||
                _vm.roomUser.roomUserRole?.mic === false) &&
              !_vm.isScreenShare
                ? _c("div", { staticClass: "v-mic-off" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/roomType/lms/img/icon_mic_off.svg"),
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
            _c("RoomSticker", {
              staticClass: "absolute inset-0",
              attrs: { "sticker-id": _vm.roomUser.stickerId },
            }),
            _vm.showParticipationRate && !_vm.videoRect.clone && !!_vm.roomUser
              ? _c("div", { staticClass: "v-participation" })
              : _vm._e(),
            _vm.networkStatus !== 0
              ? _c("div", { staticClass: "absolute top-0 left-0 p-2" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-7 h-7 rounded-full bg-red-500 flex justify-center items-center",
                    },
                    [_c("GrmIcon", { attrs: { icon: "no-signal-white" } })],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      !_vm.isScreenShare
        ? _c("div", {
            staticClass: "grm-video-layer-border",
            style: _vm.grmVideoLayerGuideStyle(_vm.videoRect),
          })
        : _vm._e(),
      _vm.isRequestSpeak
        ? _c("div", { staticClass: "request-speak" }, [
            _c("div", { staticClass: "request-speak-video-out-line" }),
            _c("div", { staticClass: "request-speak-btns-rec" }, [
              _vm.hasEmceeRole() && !_vm.isSmallLayout
                ? _c("div", { staticClass: "request-speak-btns clearfix" }, [
                    _c(
                      "button",
                      {
                        staticClass: "request-speak-btn accept",
                        on: {
                          click: function ($event) {
                            return _vm.confirmRequestSpeak({
                              reqSpeakId: _vm.reqSpeakId,
                              userId: _vm.roomUser.userId,
                              reject: false,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.apply")))]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "request-speak-btn refuse",
                        on: {
                          click: function ($event) {
                            return _vm.confirmRequestSpeak({
                              reqSpeakId: _vm.reqSpeakId,
                              userId: _vm.roomUser.userId,
                              reject: true,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.reject")))]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm.isMyScreenShareView && _vm.isScreenShare
        ? _c("RoomCallScreenShare")
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }